var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h2',{staticClass:"title",class:[_vm.size, { 'no-border': !_vm.border }, _vm.color],style:({ 'border-color': _vm.borderColor })},[_vm._v("\n  "+_vm._s(_vm.title)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }